import * as actionTypes from '../actions/actionTypes';

// Helper function
const filterObject = (obj, filter, filterValue) =>
    Object.keys(obj).reduce((acc, val) => (
        obj[val][filter] === filterValue ? acc : {
            ...acc,
            [val]: obj[val]
        }
    ), {});

// Initial state definition
const initialState = {
    // Data arrays
    projects: [],
    projectunits: [],
    productSolutions: [],
    productSystems: [],
    documentationFiles: [],
    documentationFileUserInfos: [],
    productSystemItems: [],
    users: [],
    projectOfferPositions: [],
    projectConsumptions: [],

    // Loading states
    loading_users: false,
    loading_projects: false,
    loading_project: false,
    loadingProductSolution: false,
    loadingProductSystemItems: false,
    loadingProductSystem: false,
    loadingDocumentationFiles: false,
    loadingDocumentationFileUserInfos: false,
    loading_project_offer_positions: false,
    loading_project_consumptions: false,

    // Saving states
    saving_project: false,
    update_productsolution: false,
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        // User related actions
        case actionTypes.FETCH_USERS_SUCCESS:
            return {
                ...state,
                loading_users: false,
                users: { ...state.users, ...action.values.entities.users }
            };

        case actionTypes.FETCH_USERS_START:
            return {
                ...state,
                loading_users: true,
            };

        case actionTypes.SAVE_PROFILE_SUCCESS:
            return {
                ...state,
                users: { ...state.users, ...action.values.entities.users }
            };

        case actionTypes.SAVE_SETTINGS_SUCCESS:
            return {
                ...state,
                users: { ...state.users, ...action.values.entities.users }
            };

        // Authentication actions
        case actionTypes.AUTH_LOGOUT:
            return {
                ...state,
                projects: [],
                projectunits: [],
                productSolutions: [],
                users: [],
                projectOfferPositions: [],
                projectConsumptions: [],
            };

        // Documentation file actions
        case actionTypes.DELETE_ALL_DOCUMENTATIONFILEUSERINFOS_SUCCESS:
            return {
                ...state,
                documentationFileUserInfos: []
            };

        case actionTypes.DELETE_DOCUMENTATIONFILEUSERINFOS_IN_PRODUCTSYSTEM_SUCCESS:
            return {
                ...state,
                documentationFileUserInfos: filterObject(
                    state.documentationFileUserInfos, 
                    "product_system_id", 
                    action.product_system_id
                )
            };

        case actionTypes.DELETE_DOCUMENTATIONFILEUSERINFOS_SUCCESS:
            return {
                ...state,
                documentationFileUserInfos: filterObject(
                    state.documentationFileUserInfos, 
                    "id", 
                    action.documentationFileUserInfoId
                )
            };

        case actionTypes.FETCH_DOCUMENTATIONFILEUSERINFOS_SUCCESS:
            return {
                ...state,
                documentationFileUserInfos: action.values.entities.documentation_file_user_infos,
                loadingDocumentationFileUserInfos: false
            };

        case actionTypes.FETCH_DOCUMENTATIONFILEUSERINFOS_START:
            return {
                ...state,
                loadingDocumentationFileUserInfos: true
            };

        case actionTypes.FETCH_DOCUMENTATIONFILEUSERINFOS_FAILED:
            return {
                ...state,
                loadingDocumentationFileUserInfos: false
            };

        case actionTypes.FETCH_DOCUMENTATIONFILES_SUCCESS:
            return {
                ...state,
                documentationFiles: action.values.entities.documentation_files
            };

        // Product system actions
        case actionTypes.FETCH_PRODUCTSYSTEMS_SUCCESS:
            return {
                ...state,
                productSystems: action.values.entities.product_systems
            };

        case actionTypes.FETCH_PRODUCTSOLUTION_START:
            return {
                ...state,
                loadingProductSystemItems: true
            };

        case actionTypes.FETCH_PRODUCTSOLUTION_SUCCESS:
            return {
                ...state,
                productSystemItems: action.values.entities.product_system_items,
                loadingProductSystemItems: false
            };

        case actionTypes.FETCH_PRODUCT_SYSTEM_SUCCESS:
            return {
                ...state,
                loadingProductSystem: false,
                productSystems: { ...state.productSystems, ...action.values.entities.product_systems }
            };

        case actionTypes.FETCH_PRODUCT_SYSTEM_START:
            return {
                ...state,
                loadingProductSystem: true,
            };

        // Project related actions
        case actionTypes.FETCH_PROJECTS_SUCCESS:
            return {
                ...state,
                loading_projects: false,
                projects: action.values.entities.projects,
                projectunits: action.values.entities.projectunits,
                projectOfferPositions: action.values.entities.project_offer_positions,
                projectConsumptions: action.values.entities.project_consumptions
            };

        case actionTypes.FETCH_PROJECTS_START:
            return {
                ...state,
                loading_projects: true,
            };

        case actionTypes.SAVE_PROJECT_SUCCESS:
            return {
                ...state,
                saving_project: false,
                projects: { ...state.projects, ...action.values.entities.projects }
            };

        case actionTypes.SAVE_PROJECT_START:
            return {
                ...state,
                saving_project: true,
            };

        case actionTypes.SAVE_PROJECT_FAILED:
            return {
                ...state,
                saving_project: false,
            };

        case actionTypes.FETCH_PROJECT_SUCCESS:
            return {
                ...state,
                loading_project: false,
                projects: { ...state.projects, ...action.values.entities.projects },
                projectunits: { ...state.projectunits, ...action.values.entities.projectunits },
                productSolutions: { ...state.productSolutions, ...action.values.entities.product_solutions },
                productSystems: { ...state.productSystems, ...action.values.entities.product_systems },
                projectOfferPositions: { ...state.projectOfferPositions, ...action.values.entities.project_offer_positions },
                projectConsumptions: { ...state.projectConsumptions, ...action.values.entities.project_consumptions }
            };

        case actionTypes.FETCH_PROJECT_START:
            return {
                ...state,
                loading_project: true,
            };

        case actionTypes.UPDATE_PROJECT_SUCCESS:
            return {
                ...state,
                saving_project: false,
                projects: { ...state.projects, ...action.values.entities.projects }
            };

        case actionTypes.UPDATE_PROJECT_START:
            return {
                ...state,
                saving_project: true,
            };

        case actionTypes.UPDATE_PROJECT_FAILED:
            return {
                ...state,
                saving_project: false,
            };

        case actionTypes.DELETE_PROJECT_SUCCESS:
            return {
                ...state,
                projects: filterObject(state.projects, "id", action.projectId)
            };

        case actionTypes.DELETE_PROJECTSOLUTION_SUCCESS:
            return {
                ...state,
                projectunits: { ...state.projectunits, ...action.values.entities.projectunits }
            };

        case actionTypes.CLONE_PROJECTSOLUTION_SUCCESS:
            return {
                ...state,
                projectunits: { ...state.projectunits, ...action.values.entities.projectunits },
                productSolutions: { ...state.product_solutions, ...action.values.entities.product_solutions }
            };

        case actionTypes.UPDATE_PRODUCTSOLUTION_SUCCESS:
            return {
                ...state,
                update_productsolution: false,
                productSolutions: { ...state.productSolutions, ...action.values.entities.product_solutions }
            };

        case actionTypes.UPDATE_PRODUCTSOLUTION_START:
            return {
                ...state,
                update_productsolution: true,
            };

        case actionTypes.UPDATE_PRODUCTSOLUTION_FAILED:
            return {
                ...state,
                update_productsolution: false,
            };

        case actionTypes.CALCULATE_PROJECT_CONSUMPTION_SUCCESS:
            return {
                ...state,
                projects: {
                    ...state.projects,
                    [action.project_id]: {
                        ...state.projects[action.project_id],
                        project_consumptions: action.project_consumptions_ids // Array der IDs aus dem normalisierten Ergebnis
                    }
                },
                // Komplett neue projectOfferPositions setzen, alte werden verworfen
                projectConsumptions: action.project_consumptions || {}
            };
            





        // Project offer positions actions
        case actionTypes.FETCH_PROJECT_OFFER_POSITIONS_SUCCESS:

            return {
                ...state,
                projects: {
                    ...state.projects,
                    [action.project_id]: {
                        ...state.projects[action.project_id],
                        project_offer_positions: action.project_offer_positions_ids // Array der IDs aus dem normalisierten Ergebnis
                    }
                },
                // Komplett neue projectOfferPositions setzen, alte werden verworfen
                projectOfferPositions: action.project_offer_positions || {}
            };

        case actionTypes.FETCH_PROJECT_OFFER_POSITIONS_START:
            return {
                ...state,
                loading_project_offer_positions: true,
            };  

        case actionTypes.FETCH_PROJECT_OFFER_POSITIONS_FAILED:
            return {
                ...state,
                loading_project_offer_positions: false,
            };    
            
        default:
            return state;
    }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/store/reducers/inventory.js